import React, { Component } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import { allFlattenRoutes as routes, shouldRenderRoute } from './index';
import { requestSystemAdminAccess } from '../redux/auth/actions';
import { isUserAuthenticated } from '../helpers/authUtils';
import * as layoutConstants from '../constants/layout';
import { IdentifyIfRouteIsPublic } from './accessCalculator';
import { confirmNavigation } from '../components/UnsavedChangesModal';

// All layouts/containers
import AuthLayout from '../layouts/Auth';
import VerticalLayout from '../layouts/Vertical';
import HorizontalLayout from '../layouts/Horizontal';
import DetachedLayout from '../layouts/Detached';

class Routes extends Component {
  componentDidMount() {
    if (this.props.user?.token && this.props.requestSystemAdminAccess) {
      this.props.requestSystemAdminAccess(this.props.user.token);
    }
  }

  componentDidUpdate(prevProps) {
    const token = this.props.user?.token;
    if (token && token !== prevProps.user?.token && this.props.requestSystemAdminAccess) {
      this.props.requestSystemAdminAccess(token);
    }
  }

  // returns the layout
  getLayout = () => {
    if (!isUserAuthenticated()) return AuthLayout;

    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case layoutConstants.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case layoutConstants.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  shouldComponentUpdate(nextProps, nextState) {
    let oldLayout = { ...this.props.layout };
    delete oldLayout.showRightSidebar;
    let newLayout = { ...nextProps.layout };
    delete newLayout.showRightSidebar;
    return (
      JSON.stringify(oldLayout) !== JSON.stringify(newLayout) ||
      JSON.stringify(this.props.user) !== JSON.stringify(nextProps.user) ||
      // Inputs to shouldRenderRoute() — without these the route table is
      // computed once with stale (null) values and never refreshed when
      // profileInformation or systemAdminAllowed arrive, so the Bulk Operations
      // email check stays denied and the route renders as null even though the
      // sidebar (re-rendered by AppMenu separately) shows the nav item.
      this.props.systemAdminAllowed !== nextProps.systemAdminAllowed ||
      JSON.stringify(this.props.personalInformation) !== JSON.stringify(nextProps.personalInformation)
    );
  }

  render() {
    const Layout = this.getLayout();
    if (this.props?.user == null) {
      // Redirect to login page if user is not authenticated, preserving current path for redirect after login
      const currentPath = window.location.pathname + window.location.search + window.location.hash;
      const isPublicRoute = IdentifyIfRouteIsPublic(currentPath);
      if (!isPublicRoute) {
        const loginPath = require('../constants/pagePath').LOGIN_PATH;
        window.location.replace(`${loginPath}?redirectUrl=${currentPath}`);
      }
    }
    // rendering the router with layout
    return (
      <BrowserRouter getUserConfirmation={confirmNavigation}>
        <Layout {...this.props}>
          <Switch>
            {routes.map((route, index) => {
              const canRender = shouldRenderRoute(
                route.path,
                this.props?.user,
                this.props?.systemAdminAllowed,
                false,
                this.props?.personalInformation
              );
              if (!canRender) return null;
              return (
                !route.children && (
                  <route.route
                    key={index}
                    path={route.path}
                    roles={route.roles}
                    exact={route.exact}
                    component={route.component}
                    menuOption={route.menuOption}
                  />
                )
              );
            })}
          </Switch>
        </Layout>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
    user: state.Auth.user,
    systemAdminAllowed: state.Auth.systemAdminAllowed,
    personalInformation: state.User?.profileInformation,
  };
};

export default connect(mapStateToProps, { requestSystemAdminAccess })(Routes);
